import React from 'react'
import Link from 'gatsby-link'
import logo from '../assets/images/logo-light.png'

const Menu = (props) => (
    <nav id="menu">
        <div className="inner">
            <ul className="links">
                <li><Link onClick={props.onToggleMenu} to="/about-us">About Us</Link></li>
                <li><Link onClick={props.onToggleMenu} to="/">Brand Design</Link></li>
                <li><Link onClick={props.onToggleMenu} to="/digital-realities">Digital Realities</Link></li>
                <li><Link onClick={props.onToggleMenu} to="/contact">Contact</Link></li>
            </ul>
            {/*<ul className="actions vertical">*/}
                {/*<li><a href="/contact" className="button special fit icon fa-envelope">Contact Us</a></li>*/}
            {/*</ul>*/}
        </div>
        <img src={logo} className='menu-logo' alt="Imbibe - A Brand Design Firm"/>
        <a className="close" onClick={props.onToggleMenu} href="javascript:;">Close</a>
    </nav>
)

Menu.propTypes = {
    onToggleMenu: React.PropTypes.func
}

export default Menu



// WEBPACK FOOTER //
// ./src/components/Menu.js